import { post, getToken, get } from "../../api/axiosApi";
import { env } from "utils/env";
import { objToQueryString } from "utils/functions";

const url = env.REACT_APP_LSNG_API_URL;

const getLogs = (filters, pager) => {
  const qs = objToQueryString({ ...filters, ...pager });
  return get(`${url}/logs?${qs}`);
};
const exportLogs = (filters, fileType) => post(`${url}/logs/exportLogs/list`, { ...filters, fileType: fileType });
const buildLogsExportDownloadUrl = (filePath, fileName) =>
  `${url}/logs/exportsLogs/file/${encodeURIComponent(filePath)}/${encodeURIComponent(
    fileName
  )}?access_token=${getToken()}`;
const getLevels = () => get(`${url}/logs/levels`);
const getLogAccordingToLogId = id => get(`${url}/logs/${id}`);
const getLogAccordingToCorrelationId = correlationId => post(`${url}/logs/${correlationId}`);

const exp = {
  getLogs,
  exportLogs,
  buildLogsExportDownloadUrl,
  getLevels,
  getLogAccordingToLogId,
  getLogAccordingToCorrelationId
};

export default exp;
